// FIXME: Update this file to be type safe and remove this and next line
// @ts-strict-ignore
export class Account {
  id: string;
  name: string;
  username: string;
  password: string;
  url: string;
  path: string;
  notes: string;
  totp: string;
  isFavorite: boolean;
  isShared: boolean;
}
